import { gql, useMutation } from '@apollo/client';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { TOAST_ACTIONS } from '../constants';

export const ArchiveAnonCriteriaMutation = gql`
  mutation archiveAnonCriteria($id: Long!, $isArchived: Boolean!) {
    toggleArchiveStateAnonUserCriteria(id: $id, isArchived: $isArchived)
  }
`;

export const useToggleArchiveAnonCriteria = (criteriaName: string) => {
  const dispatch = useDispatch();

  const [toggleCriteriaArchive, { error }] = useMutation(ArchiveAnonCriteriaMutation, {
    onError: (e, options) => {
      dispatch(
        addNegativeToastWithErrorId(
          <>
            Error {options?.variables?.isArchived ? 'archiving' : 'unarchiving'}{' '}
            <strong>{criteriaName}</strong>. Please try again.
          </>,
          options?.variables?.isArchived
            ? TOAST_ACTIONS.archiveCriteria
            : TOAST_ACTIONS.unarchiveCriteria,
          e,
        ),
      );
      options?.client?.cache.evict({ id: 'ROOT_QUERY', fieldName: 'getAnonCriterias' });
    },
    onCompleted: (_, options) => {
      dispatch(
        addPositiveToast(
          <>
            <strong>{criteriaName}</strong> successfully{' '}
            {options?.variables?.isArchived ? 'archived' : 'unarchived'}.
          </>,
        ),
      );
    },
  });

  return {
    toggleCriteriaArchive,
    error,
  };
};
